var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXtwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2116_1140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1692 10.1628L22.6556 0H20.6444L13.274 8.8236L7.38921 0H0.599609L9.50121 13.344L0.599609 24H2.61081L10.394 14.682L16.61 24H23.3996L14.1692 10.1628ZM11.414 13.4604L10.5116 12.132L3.33561 1.56H6.42561L12.2168 10.092L13.118 11.4204L20.6456 22.5108H17.5568L11.414 13.4604Z",
    fill: "#1877F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2116_1140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXtwitter);
export default __webpack_public_path__ + "static/media/xtwitter.2656832a9c5a808786f751e6262e1ae0.svg";
export { ForwardRef as ReactComponent };